import axios from "./index";

export default {
  getAll() {
    return axios.get("/v1/banner");
  },
  updateBanner(data) {
    return axios.put("/v1/banner", data);
  },
  getAllVideoBackground() {
    return axios.get("/v1/banner/video");
  },
  updateVideoBackground(data) {
    return axios.put("/v1/banner/video", data);
  },
  uploadFile(formData) {
    return axios.post(`/v1/banner/upload`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },
};
